import type { WhatsAppContentKindCode } from "@gioia365/contracts";
import type { MessageKey } from "@gioia365/i18n";

// Che cosa ha mandato il Lead, quando non è un testo (piano M6, R3; questione 425): Gioia365 non lo scarica, e la frase dice di aprirlo
// sul telefono. La stessa frase nella Timeline, nella lista di «Conversazioni → WhatsApp» e nella finestra «Rispondi su WhatsApp».

type InboundKindKey = Extract<MessageKey, `timeline.whatsapp.inboundKinds.${string}`>;

const INBOUND_KINDS: Record<Exclude<WhatsAppContentKindCode, "text">, InboundKindKey> = {
  image: "timeline.whatsapp.inboundKinds.image",
  audio: "timeline.whatsapp.inboundKinds.audio",
  video: "timeline.whatsapp.inboundKinds.video",
  document: "timeline.whatsapp.inboundKinds.document",
  sticker: "timeline.whatsapp.inboundKinds.sticker",
  location: "timeline.whatsapp.inboundKinds.location",
  contacts: "timeline.whatsapp.inboundKinds.contacts",
  other: "timeline.whatsapp.inboundKinds.other",
};

/** La frase per ciò che il Lead ha mandato; `null` per un testo, o per un messaggio in uscita (senza tipo). */
export function inboundKindKey(kind: WhatsAppContentKindCode | null): InboundKindKey | null {
  return kind === null || kind === "text" ? null : INBOUND_KINDS[kind];
}
